import React from 'react';
import { Confirm, Header, Icon, Popup, Table } from 'semantic-ui-react';
import { Atencion } from '../tipos';

interface Props {
    atenciones: Array<Atencion>;
    alRevertir(idAtencionARevertir: string): void;
}

interface State {
    idAtencionARevertir: string | undefined;
}

class TablaDeAtenciones extends React.PureComponent<Props, State> {
    public state: State = {
        idAtencionARevertir: undefined,
    };

    public render() {
        const { atenciones } = this.props;
        return (
            <div>
                <Header as='h2'>Personas ya atendidas</Header>
                {!!this.state.idAtencionARevertir && this.modalRevertirAtencion()}
                <Table compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell content='Nombre' />
                            <Table.HeaderCell content='Hora de llegada' />
                            <Table.HeaderCell content='Hora de atención' />
                            <Table.HeaderCell content='Medio de información' />
                            <Table.HeaderCell content='Asesor' />
                            <Table.HeaderCell />
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {atenciones.map(atencion => (
                            <Fila
                                key={atencion.idAtencion}
                                {...atencion}
                                alPresionarRevertir={() => {
                                    this.setState({
                                        idAtencionARevertir: atencion.idAtencion,
                                    });
                                }}
                            />
                        ))}
                    </Table.Body>
                </Table>
            </div>
        );
    }
    private modalRevertirAtencion(): React.ReactNode {
        return (
            <Confirm
                open
                size='mini'
                dimmer='blurring'
                content='¿Está seguro que quiere revertir esta atención?'
                confirmButton='Sí'
                cancelButton='No'
                onConfirm={() => {
                    this.props.alRevertir(this.state.idAtencionARevertir!);
                    this.setState({ idAtencionARevertir: undefined });
                }}
                onCancel={() => this.setState({ idAtencionARevertir: undefined })}
            />
        );
    }
}

class Fila extends React.Component<
    Atencion & { alPresionarRevertir(): void },
    { encima: boolean }
> {
    public state = { encima: false };

    public render() {
        const visible = this.state.encima;

        const iconoStyle = { visibility: visible ? 'initial' : 'hidden' };

        return (
            <Table.Row
                onMouseOver={() =>
                    this.setState({
                        encima: true,
                    })
                }
                onMouseLeave={() => this.setState({ encima: false })}
            >
                <Table.Cell content={this.props.nombre} />
                <Table.Cell content={this.props.horaDeLlegada} />
                <Table.Cell content={this.props.horaDeAtencion} />
                <Table.Cell content={this.props.medioDeInformacion} />
                <Table.Cell content={this.props.asesor} />
                <Table.Cell textAlign='right'>
                    <Popup
                        trigger={
                            <Icon
                                circular
                                link
                                name='undo'
                                style={iconoStyle}
                                onClick={this.props.alPresionarRevertir}
                            />
                        }
                        content='Revertir atención'
                        inverted
                    />
                </Table.Cell>
            </Table.Row>
        );
    }
}
export default TablaDeAtenciones;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/componentes/TablaDeAtenciones.tsx